import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const EmptyState = ({ icon: Icon, title, body, ctaLabel, onCta, testId = "empty-state" }) => (
  <Card className="border-dashed" data-testid={testId}>
    <CardContent className="py-14 flex flex-col items-center text-center">
      {Icon && (
        <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-secondary">
          <Icon className="h-6 w-6 text-muted-foreground" />
        </div>
      )}
      <h3 className="text-lg font-semibold">{title}</h3>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground leading-relaxed">{body}</p>
      {ctaLabel && (
        <Button className="mt-6 rounded-xl" onClick={onCta} data-testid={`${testId}-cta`}>
          {ctaLabel}
        </Button>
      )}
    </CardContent>
  </Card>
);
